import { appTypeId } from '../../../models/application-types';

export class Controller {

    /** @ngInject */
    constructor($state, AddNewApplicationResource) {
        this.state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    showAddApplicationModal() {
        this.AddNewApplicationResource
            .createSecureApp(this.companyId, appTypeId('google-apps'))
            .then(app => this.state.go('company.manage-application', {appId: app.id}));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/google-marketplace-instructions/google-marketplace-instructions.controller.js